import {
    List,
    TextField,
    Datagrid,
    DateField,
    ReferenceField,
    SelectField,
    DateInput,
    useRecordContext
} from 'react-admin';
import {permissionManager} from "../permissions/manager";
import {
    Box,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableHead,
    TableContainer
} from '@mui/material';

const typeChoices = [
    { id: 'workflow_create', name: 'Workflow Create' },
    { id: 'workflow_test', name: 'Workflow Test' },
    { id: 'workflow', name: 'Workflow' },
    { id: 'chat', name: 'Chat' },
];

const postFilters = [
    <DateInput label="Title" source="createdAt" />,
];

const ExpandableRow = () => {
    const record = useRecordContext();
    console.log(record);
    return (
        <TableContainer  sx={{ maxHeight: 400 }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell >{ "Node ID" }</TableCell>
                        <TableCell >{ "Request Tokens" }</TableCell>
                        <TableCell >{ "Response Tokens" }</TableCell>
                        <TableCell >{ "Tokens per Second" }</TableCell>
                        <TableCell >{ "Execution Time (Seconds)" }</TableCell>
                        <TableCell >{ "Number of Requests" }</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { record?.data?.map((datum: any, index: number) => {
                        return (
                            <TableRow key={ "collapsible_table_row_" + index }>
                                <TableCell >{ datum.node_id }</TableCell>
                                <TableCell >{ datum.request }</TableCell>
                                <TableCell >{ datum.response }</TableCell>
                                <TableCell >{ datum.tokens_per_second.toFixed(2) }</TableCell>
                                <TableCell >{ datum.duration.toFixed(2) }</TableCell>
                                <TableCell >{ datum.requests ?? 'N/A' }</TableCell>
                            </TableRow>
                        );
                    } ) }
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export const TokenHistoryList = () => {

    return (
        <List
            actions={ false }
            sort={ { field: 'id', order: 'DESC' } }
            filters={ postFilters }
        >
            <Datagrid bulkActionButtons={false} expand={ <ExpandableRow /> } >
                <TextField source="id" />
                <ReferenceField source="workflow" reference="workflows">
                    <TextField source="name" />
                </ReferenceField>
                <SelectField source="type" choices={ typeChoices } />
                <TextField source="requestTokens" />
                <TextField source="responseTokens" />
                <TextField source="totalTokens" />
                <DateField showTime source="createdAt" />
            </Datagrid>
        </List>
    );
}
